import { useGetClusters } from 'queries';
import { useTranslation } from 'react-i18next';

import { CLUSTERS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditForm from './components/CreateEditForm';

import { useFixedColumns } from './hooks/useFixedColumns';

const Clusters = () => {
  const { t } = useTranslation('common');

  const columns = useFixedColumns();
  const { mutate: handleDelete } = useDeleteById(CLUSTERS, ['clusters']);
  const { data, isFetching } = useGetClusters();

  return (
    <TableCRUDLayout
      FormComponent={CreateEditForm}
      rows={data}
      loading={isFetching}
      columns={columns}
      getRowId={(row) => row.clusterId}
      onDeleteClick={(rowId) => handleDelete(rowId)}
      confirmationTitle={t('adminPortal.clusters.deleteDialog.title')}
      confirmationBody={t('adminPortal.clusters.deleteDialog.body')}
    />
  );
};

export default Clusters;
